import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import {
  SettingsService,
  SettingType,
} from 'src/app/core/settings/settings.service';
import { Entity } from 'src/app/shared/entity-search/entity-search.service';
import { Company } from '../request-creation-modal/models/company';

@Component({
  selector: 'dcc-settings-top-bar',
  templateUrl: './settings-top-bar.component.html',
  styleUrls: ['./settings-top-bar.component.scss'],
})
export class SettingsTopBarComponent {
  @Input()
  company: Company;

  @Output()
  settingsSearch: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  entitySelect: EventEmitter<Entity> = new EventEmitter<Entity>();

  settingFilter = '';

  private settingTypes: SettingType[];

  constructor(private settingsService: SettingsService) {
    this.searchSettings = this.searchSettings.bind(this);
    this.settingTypes = this.settingsService.getAllSettingTypes();
  }

  searchSettings(searched: Observable<string>): Observable<SettingType[]> {
    return searched.pipe(
      distinctUntilChanged(),
      map((term) =>
        this.settingTypes.filter(
          (s) =>
            !s.isLegacy &&
            s.label.toLocaleLowerCase().includes(term.toLocaleLowerCase()),
        ),
      ),
    );
  }

  formatter(result: SettingType): string {
    return result.label;
  }

  onSelectItem(selectedItem: { item: SettingType }): void {
    this.settingsSearch.emit(selectedItem.item.name);
  }

  onEntitySelected(entity: Entity): void {
    this.entitySelect.emit(entity);
  }

  reset(): void {
    this.settingFilter = '';
  }

  resetCompany(): void {
    this.company = undefined;
  }
}
